import { render, staticRenderFns } from "./RegulatoryUpdates.vue?vue&type=template&id=13762ae4&scoped=true"
import script from "./RegulatoryUpdates.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegulatoryUpdates.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RegulatoryUpdates.vue?vue&type=style&index=0&id=13762ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13762ae4",
  null
  
)

export default component.exports